import React from 'react'
import styles from './ErrorRole.module.css'
import imgLogo from '../../img/logo-login.94cc99f3.png'

const ErrorRole = ({ onclick }) => {

    return (
        <div className={styles.container}>
            <div className={styles.flex}>
                <div>
                    <img className={styles.imgFlex} src={imgLogo} alt="" />
                </div>
                <div className={styles.titleFlex}>
                    <div>
                        <label className={styles.title}>
                            ¡Lo sentimos!
                        </label>
                    </div>
                </div>
                <div className={styles.flexLetter}>
                    <label className={styles.letter}>
                        Estimado usuario usted no cuenta con permisos para ingresar a la
                        aplicación Solicitud Digital Web.
                        Por favor vuelva a intentarlo.
                    </label>
                </div>

                <div className={styles.flexButton}>
                    <button className={styles.button} onClick={onclick}>
                        Salir
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ErrorRole